import { Badge } from '@/components/ui/badge'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorMetricsCard } from '../components/processor-metrics-card'
import { ProcessorPaymentMethodsCard } from '../components/processor-payment-methods-card'

interface BlueSnapProcessorDetailsPageProps {
    processor: ProcessorDetails
}

const BlueSnapConfigurationCard = ({ processor }: BlueSnapProcessorDetailsPageProps) => {
    const options = processor.options as Record<string, any> | null

    return (
        <Card className="mb-6">
            <CardHeader><CardTitle>BlueSnap Configuration</CardTitle></CardHeader>
            <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <p className="text-sm text-muted-foreground">API Username</p>
                        <p className="font-mono text-sm">{options?.apiUsername || 'Not configured'}</p>
                    </div>
                    <div>
                        <p className="text-sm text-muted-foreground">API Password</p>
                        <p className="font-mono text-sm">••••••••••••••••</p>
                    </div>
                    <div>
                        <p className="text-sm text-muted-foreground">Environment</p>
                        <Badge variant={options?.testMode ? 'outline' : 'default'}>
                            {options?.testMode ? 'Sandbox' : 'Production'}
                        </Badge>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

export const BlueSnapProcessorDetailsPage = ({ processor }: BlueSnapProcessorDetailsPageProps) => {
    return (
        <>
            <ProcessorHeader type="bluesnap" processor={processor} />
            <ProcessorOverviewCard processor={processor} />
            <ProcessorMetricsCard processor={processor} />
            <BlueSnapConfigurationCard processor={processor} />
            <ProcessorPaymentMethodsCard processor={processor} />
        </>
    )
}
